import { Component, Input } from "@angular/core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { lastValueFrom } from "rxjs";
import { Certificate } from "src/app/models/Certificate";
import { EventDocument } from "src/app/models/EventDocument";

import { EventService } from "./../../services/event.service";
import { FileService } from "./../../services/file.service";

@Component({
  selector: "download-file",
  templateUrl: "./download-file.component.html",
  styleUrls: ["./download-file.component.scss"],
  standalone: false,
})
export class DownloadFileComponent {
  faDownload = faDownload;
  @Input() file: EventDocument | Certificate;

  constructor(
    private eventService: EventService,
    private fileService: FileService,
  ) {}

  async download() {
    const data = await lastValueFrom(this.eventService.getDocument(this.file));
    this.fileService.downloadFile(data, this.file.fileName);
  }
}
